module.exports = __webpack_public_path__ + "static/media/body_ache.d09e1795.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/symptoms/body_ache.png
// module id = 391
// module chunks = 0